<footer class="text-lg-start">
  <div class="bfs-footer">
    <div class="container">
        <div class="bfs-footer-items">
            <div class="bfs-copyright">
                 &copy;<strong>2026</strong>&nbsp;<a href="https://www.bfs.de" target="_blank">Bundesamt für Strahlenschutz</a>
            </div>
            <ul class="footer-menu">
                <li><a routerLink="info/impressum" title="Link Impressum">{{ 'footer.link.imprint' | translate}}</a></li>
                <li><a href="https://www.bfs.de/datenschutz" target="_blank" title="Link Datenschutzerklärung">{{ 'footer.link.privacy-policy' | translate}}</a></li>
                <li><a routerLink="info/barrierefreiheit" title="Link Barrierefreiheitserklärung">{{ 'footer.link.accessibility-bfs' | translate}}</a></li>
                <li><a href="https://www.bfs.de/social-media" target="_blank" title="Link Social Media und Netiquette">Social Media</a></li>
                <li *ngIf="showCookieSettings" title="Link Cookie-Einstellungen">
                  <button class="cookies-link" type="button" (click)="openCookieSettings()" role="button" tabindex="0">
                    {{ 'footer.link.cookies' | translate}}
                  </button>
                </li>
            </ul>
        </div>
        <div class="footer-social">
            <ul>
            <li><a href="https://www.instagram.com/strahlenschutz_bfs" target="_blank"><img src="assets/bfs/images/instagram_white.png" height="20" alt="Instagram"/></a></li>
            <li><a href="https://www.linkedin.com/company/bundesamt-fuer-strahlenschutz-bfs-/" target="_blank"><img src="assets/bfs/images/linkedin_white.png" height="20" alt="LinkedIn"/></a></li>
            <li><a href="https://www.youtube.com/bfsbund" target="_blank"><img src="assets/bfs/images/youtube_white.png" height="20" alt="YouTube"/></a></li>
            <li><a href="https://social.bund.de/@strahlenschutz" target="_blank"><img src="assets/bfs/images/mastodon_white.png" height="20" alt="mastodon"/></a></li>
            <li><a href="https://twitter.com/strahlenschutz" target="_blank"><img src="assets/bfs/images/twitter_white.png" height="20" alt="X"/></a></li>
            </ul>
        </div>
    </div>
  </div>
</footer>
